import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ApprovalStatus} from '../../approvers'

import {QueryKey} from './useEventsAffiliate'

type UseApprovalParams = {
  plantId: string
}

export const useApprovalAffiliate = ({plantId}: UseApprovalParams) => {
  const queryClient = useQueryClient()

  return useMutation<never, AxiosError, {eventId: string; approvalStatus: ApprovalStatus}>({
    mutationFn: async ({eventId, approvalStatus}) => {
      const path = `/shifthandover/${plantId}/events/${eventId}/approval-affiliate`
      const {data} = await ApiClient.axiosInstance.put<never>(path, approvalStatus, {
        headers: {'Content-Type': 'application/json'}
      })
      return data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: [QueryKey]})
    }
  })
}
